import React from "react";

const StatusBarStyle = ({ children, statusBarStyle }) => {
  return null;
};

export { StatusBarStyle };
